import { AnyAction } from "redux";
import {
  FETCH_PAY_PAGE_ERROR,
  FETCH_PAY_PAGE_SUCCESS,
  REQUEST_FETCH_PAY_PAGE,
} from "redux/actions/pages/pay";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_PAY_PAGE:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PAY_PAGE_SUCCESS:
      return {
        data: action.pay,
        error: null,
        loading: false,
      };
    case FETCH_PAY_PAGE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
